export default __webpack_public_path__ + "static/question-bg-7dedc4b7d7be52479a6e98da23d9bd8c.png";